var filesize = require('filesize');
var sprintf = require('sprintf-js').sprintf;
var React = require('react');
var cx = require('classnames');

var Bandwidth = require('../../util/Bandwidth');
var Bullet = require('../Chart/Bullet');

var Bar = React.createClass({
    propTypes: {
        limits: React.PropTypes.arrayOf(React.PropTypes.number),
        nearThreshold: React.PropTypes.number,
        title: React.PropTypes.string.isRequired,
        usage: React.PropTypes.number.isRequired,
        width: React.PropTypes.number.isRequired
    },

    render: function () {
        var highLimit = this.props.limits[this.props.limits.length-1];
        var usage = this.props.usage;
        if (isNaN(usage)) {
            usage = 0;
        }
        var data = sprintf('%1$s of %2$s used', Bandwidth.format(usage, 2), Bandwidth.format(highLimit, 2));

        var classes = {
            'over': usage > highLimit,
            'near': this.props.nearThreshold && usage < highLimit && (usage > highLimit * this.props.nearThreshold)
        };

        var chartLimits = this.props.limits.map(function (limit) {
            return limit / 1000000000;
        });
        var chartUsage = usage / 1000000000;

        return <div className={cx('bandwidth-bar', classes)}>
            <strong>{this.props.title}</strong>: {data}

            <Bullet ranges={chartLimits} measures={[chartUsage]} markers={[chartUsage]} width={this.props.width} height={50} />
        </div>;
    }
})
module.exports = Bar;



// WEBPACK FOOTER //
// ./app/components/Bandwidth/Bar.js